module.exports = __webpack_public_path__ + "img/kings_canyon_ba_list.d1001b8b.jpg";